<template>
	<div>
		<span class="biaoti">分类管理</span>
		<Fenlei v-model="shu"></Fenlei>
		<Tijiao @click="Tijiao" wenzi="保存" class="p_adding"></Tijiao>
	</div>
</template>

<script>
	let that;
	import Fenlei from '../../zujian/Fenlei.vue'
	export default {
		data() {
			return {
				shu: [{}]
			}
		},
		components: {
			Fenlei
		},
		created() {
			that = this;
			that.CSH();
		},
		methods: {
			CSH() {
				this.$post('m=zw_pige&k=shangpin&c=quanbufenlei', function(s) {
					if (s.shu.length>0) {
						that.shu = s.shu;
					}
				});
			},
			Tijiao() {
				this.$post('m=zw_pige&k=shangpin&c=xiugaifenlei',{fenlei:this.shu}, function(s) {
					that.$xiaoxi(s.shu);
					if(s.shi==1){
						that.CSH();
					}
				});
			}
		}

	}
</script>

<style>
.p_adding{margin-top: 20px;}
</style>
